import {
	useFreeIntent,
	usePremiumIntent,
	useStandardIntent,
} from '@/components/user-context/helpers/cohorts';
import { useIsMobile } from '@/utils/useIsMobile';

import { SignupDefault } from '../../components/signup-default';

import { LoggedInJpdFree } from './free/logged-in-jpd-free';
import { LoggedInJpdPremium } from './premium/logged-in-jpd-premium';
import { LoggedInJpdStandard } from './standard/logged-in-jpd-standard';

export const LoggedInJpd = () => {
	const isMobile = useIsMobile();
	return isMobile ? <SignupDefault /> : <CohortComponent />;
};

const CohortComponent = () => {
	const isStandard = useStandardIntent();
	const isPremium = usePremiumIntent();
	const isFree = useFreeIntent();

	if (isFree) {
		return <LoggedInJpdFree />;
	}

	if (isStandard) {
		return <LoggedInJpdStandard />;
	}

	if (isPremium) {
		return <LoggedInJpdPremium />;
	}

	// bxpkit catch-all (paid editions if gate is off)
	return <SignupDefault />;
};
